import React from 'react';
import { Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Uploader } from 'ui/components';
import { Skeletons, SkeletonText } from 'ui/components/skeleton';

const initialState = {
  isShow: false,
  zoomImg: null,
  temp: [],
  imgShow: 4,
};

export const UploadPOD = ({ onImageChange, isLoading, errors }) => {
  const dummy = Array.from({ length: 2 }, (v, i) => i);
  const [{ temp, isShow, zoomImg, imgShow }, setState] =
    React.useState(initialState);

  const $removeImg = async (i) => {
    let newImg = [...temp];
    newImg.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      temp: newImg,
    }));
  };

  React.useEffect(() => {
    if (!temp) return;
    onImageChange(temp);
  }, [temp]);

  return (
    <section className="" id="doc">
      {isLoading ? (
        <div style={{ width: 100 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="form-label required fs-8">POD</div>
      )}

      {isLoading ? (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-start mt-n1">
          {dummy?.map((d, i) => (
            <Skeletons width="50px" height="50px" key={i} />
          ))}
          <Skeletons width="50px" height="50px" />
        </div>
      ) : (
        <div>
          <div
            className={cn(
              'd-flex flex-wrap pb-2 gap-2 align-items-center justify-content-start'
            )}
          >
            <Uploader
              small
              setData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  temp: [...temp, ...e],
                }))
              }
              errors={errors}
            />

            {temp?.slice(0, imgShow)?.map((d, i) => (
              <div
                className="position-relative d-flex justify-content-center align-items-center"
                key={i}
              >
                <span
                  className="position-absolute bg-danger rounded-circle top-0 end-0 zIndex-up d-flex justify-content-center align-items-center cursor-pointer me-n1 mt-n1"
                  style={{ height: 15, width: 15 }}
                  onClick={() => $removeImg(i)}
                >
                  <Fi.FiX color="white" size={10} />
                </span>
                <img
                  className="rounded-3 cursor-pointer"
                  src={d}
                  alt=""
                  style={{ width: 50, height: 50 }}
                  onClick={() => {
                    setState((prevState) => ({
                      ...prevState,
                      isShow: true,
                      zoomImg: d,
                    }));
                  }}
                />
              </div>
            ))}

            {temp?.length > 4 ? (
              imgShow < temp?.length ? (
                <div
                  className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader "
                  onClick={() =>
                    setState((prevState) => ({
                      ...prevState,
                      imgShow: temp?.length,
                    }))
                  }
                  style={{ cursor: 'pointer', height: 50, width: 50 }}
                >
                  <div
                    className=""
                    style={{
                      textOrientation: 'upright',
                      writingMode: 'horizontal-tb',
                      textAlign: 'center',
                      fontSize: 10,
                    }}
                  >
                    Lihat semua <Fi.FiChevronsRight />
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader "
                  onClick={() =>
                    setState((prevState) => ({
                      ...prevState,
                      imgShow: 4,
                    }))
                  }
                  style={{ cursor: 'pointer', height: 50, width: 50 }}
                >
                  <div
                    className=""
                    style={{
                      textOrientation: 'upright',
                      writingMode: 'horizontal-tb',
                      textAlign: 'center',
                      fontSize: 10,
                    }}
                  >
                    <Fi.FiChevronsLeft />
                    Tutup
                  </div>
                </div>
              )
            ) : null}
          </div>
          {errors && (
            <div
              className="invalid-feedback mt-n1"
              style={{ display: 'block' }}
            >
              {errors}
            </div>
          )}
        </div>
      )}

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({
            ...prevState,
            isShow: false,
          }))
        }
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                isShow: false,
              }))
            }
          />
          <div className="text-center mt-4">
            <img src={zoomImg?.replace('_thumb', '')} alt="" />
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <div
            className="btn btn-danger"
            onClick={() => $deleteImage(zoomImg?.id)}
          >
            Hapus Gambar
          </div>
        </Modal.Footer> */}
      </Modal>
    </section>
  );
};
